import { ProductListByIds } from './product-list-by-ids'

export { ProductListByIds } from './product-list-by-ids'

export default ProductListByIds
